/* Editorial interactions only: no cart, consent or analytics changes. */
(() => {
 function init(scope = document) {
  scope.querySelectorAll('[data-journal]').forEach(root => {
   const nav = root.querySelector('[data-journal-categories]');
   if (!nav || nav.dataset.ready) return;
   nav.dataset.ready = 'true';
   const cards = [...root.querySelectorAll('[data-journal-category]')];
   const available = new Set(cards.flatMap(card => card.dataset.journalTags.split('|')));
   nav.querySelectorAll('[data-journal-filter]').forEach(button => {
    button.hidden = button.dataset.journalFilter !== 'all' && !available.has(button.dataset.journalFilter);
   });
   nav.hidden = !cards.length;
   nav.addEventListener('click', event => {
    const button = event.target.closest('[data-journal-filter]');
    if (!button) return;
    let count = 0;
    cards.forEach(card => {
     card.hidden = button.dataset.journalFilter !== 'all' && !card.dataset.journalTags.split('|').includes(button.dataset.journalFilter);
     if (!card.hidden) count++;
    });
    nav.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    root.querySelector('[data-journal-empty]').hidden = count > 0;
   });
  });
  scope.querySelectorAll('[data-native-article]').forEach(body => {
   const toc = body.closest('article').querySelector('[data-native-toc]');
   const headings = [...body.querySelectorAll('h2')];
   if (!toc || headings.length < 3 || toc.dataset.ready) return;
   toc.dataset.ready = 'true';
   headings.forEach((heading, index) => {
    if (!heading.id) {
     let id = `lecture-${index + 1}`;
     while (document.getElementById(id)) id += '-s';
     heading.id = id;
    }
    const link = document.createElement('a');
    link.href = '#' + heading.id;
    link.textContent = heading.textContent;
    toc.querySelector('nav').append(link);
   });
   toc.hidden = false;
  });
 }
 init();
 document.addEventListener('shopify:section:load', event => init(event.target));
})();
